import { StandardProps } from "../componentMap";
import styles from "./OutOfStockStatusMessage.module.scss";
import { hasAnyStock } from "../../utils/product/hasAnyStock";

export function OutOfStockStatusMessage({
  product,
}: Pick<StandardProps, "product">) {
  if (product.variants.length === 1 || hasAnyStock(product)) {
    return null;
  }

  return (
    <p className={styles.statusMessage}>
      We&apos;re sorry, this item is currently out of stock online
    </p>
  );
}
